import { Box, genesisStyled } from '@leagueplatform/genesis-commons';

export const ActivityContainer = genesisStyled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  grid-auto-rows: 1fr;
  grid-row-gap: ${({ theme }) => theme.space.one}px;
  grid-column-gap: ${({ theme }) => theme.space.oneAndHalf}px;
`;
